import React from 'react';

import { classesData } from 'data/javascript/classes';

import DescriptionEntry from 'components/shared/description-entry';

const ClassSyntax = () => {
  const item = classesData?.items.find(
    (item) => item.title === 'Class Syntax'
  );

  return <DescriptionEntry entry={item} />;
};

export default ClassSyntax;
